export default __webpack_public_path__ + "static/fonts/Jaymont-Bold.1b01a5d.woff";